import React from "react";
import { Grid, TextField, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { CloudRegionSelector } from "components/CloudRegionSelector/CloudRegionSelector";
import { CloudSubscriptionMaintenanceWindowForm } from "../../../cloud-subscriptions/components/forms/CloudSubscriptionMaintenanceWindowForm";

const dnsPrefixOptions = {
  required: {
    value: true,
    message: "Please enter a DNS Prefix.",
  },
  maxLength: {
    value: 255,
    message: "DNS Prefix is too long.",
  },
  pattern: {
    value: /^[a-z0-9]([a-z0-9-]*[a-z0-9])?$/,
    message:
      "DNS Prefix must contain only lowercase letters, numbers, and hyphens, and cannot start or end with a hyphen.",
  },
};

export function CloudPlatformFields() {
  const { register, control, formState } = useFormContext();

  return (
    <>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <TextField
          fullWidth
          required
          label="DNS Prefix"
          error={!!formState?.errors?.dnsPrefix}
          helperText={formState?.errors?.dnsPrefix?.message?.toString()}
          {...register("dnsPrefix", dnsPrefixOptions)}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <CloudRegionSelector
          name="cloudRegion"
          label="Cloud Region"
          control={control}
          required={true}
          rules={{
            required: {
              value: true,
              message: "Please select a cloud region",
            },
          }}
        />
      </Grid>
    </>
  );
}

export function CloudMaintenanceWindowFields() {
  return (
    <>
      <Grid size={12}>
        <Typography variant="h6" sx={{ mb: 1, mt: 2 }}>
          Maintenance Window
        </Typography>
      </Grid>
      <Grid size={12}>
        <CloudSubscriptionMaintenanceWindowForm />
      </Grid>
    </>
  );
}
